import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    body {
        line-height: 1;
        background: var(--cinza);
    }
  
    .modal-open {
        overflow: hidden;
    }

    img {
        width: inherit;
    }

    input, textarea, select {
        border: none;
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        font-family: inherit;
    }

    /* Estilos Globais */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: sans-serif;
    }

    *::-webkit-scrollbar {
        width: 8px;
    }

    *::-webkit-scrollbar-thumb {
        background: var(--cor-primaria);
        border-radius: 10px;
    }

    :root {
        --background:rgb(66, 238, 221);
        --background-dark:  radial-gradient(circle,rgb(49, 49, 49) 0%, rgb(39, 39, 39) 60%);
        --fonte-dark-eee:#F0F0F0;
        --conteiner-dark-eee:#4D4D4D;
        --cor-primaria: #0066CC;
        --cor-secundaria: #009DD7;
        --poco-fundo:#3D3D3D;
        --cor-contraste:rgb(0, 61, 131);
        --cor-hover:rgb(160, 160, 160);
        --cor-hoverHome: #0A7EFF;
        --cor-infor: #60abff;
        --cor-cinza:rgb(177, 177, 177);
        --shadow:rgba(0, 0, 0, 0.5);
        --branco: #FFFFFF;
        --cinza: radial-gradient(circle, rgba(255, 255, 255, 1) 50%, rgba(213, 213, 213, 1) 99%);
        --cor-erro: #9A1B00;
        --cor-hoverErro: #ED3F19;
        --liquido: #60ABFF;
        --alerta: red;
        --offline: red;
        --online:rgba(67, 225, 4, 1);
        --desligado: #60abff;
        --ligado: green;
        --degrade: radial-gradient(circle, #0066CC  80%, #009DD7 130%);
    }

    @keyframes blink {
    0% {background-color: red;}
    50% { background-color: transparent; }
    100% {background-color: red;}
    }

    .blink {
    animation: blink 0.5s infinite;
    }

    @keyframes myAnim {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes alertAnim {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }


@keyframes slide-bottom {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-100px);
            transform: translateY(-100px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}

@keyframes giroBomba {

0% {
transform: rotate(0deg);
}
100% {
transform: rotate(360deg);
}
}
`;
